export interface LoginRequest {
    email: string;
    password: string;
    platform?: LoginRequestPlatformEnum;
}

export enum LoginRequestPlatformEnum {
    Web = 'WEB',
    AgentDesktop = 'AGENT_DESKTOP',
    Generic = 'GENERIC',
}

export interface LoginResponse {
    token: TokenInfo;
    user: AuthenticatedUser;
    menu: MenuItem[];
}

export interface TokenInfo {
    access_token: string;
    refresh_token?: string;
    token_type: string;
    expires_in: number;
}

export interface AuthenticatedUser {
    user_id: number;
    username: string;
    email: string;
    employee_id?: number;
    role: UserRoleBasic;
}

export interface UserRoleBasic {
    role_id: number;
    name: string;
}

export enum PermissionType {
    MenuParent = 'MENU_PARENT',
    MenuItem = 'MENU_ITEM',
    Action = 'ACTION',
}

export interface MenuItem {
    permission_id: number;
    code: string;
    name: string;
    permission_type: PermissionType;
    icon?: string;
    order: number;
    route?: string;
    children: MenuItem[];
}

export interface RolePermissions {
    allowRead: boolean;
    allowCreate: boolean;
    allowUpdate: boolean;
    allowDelete: boolean;
}
